import React from "react";
import AppConstants from "../../classes/constants";
import appStyles from "../../../app.module.css";
import rsStyles from "../recent-settlement.module.css";
import NumericFormat from "react-number-format"

const SettlementsDetails = (props) => {
  const { settlementDetails } = props;
  return (
    <>
      <div className={rsStyles.recentSettlementDetailsWrap}>
        <div className={rsStyles.recentSettlementDetailsIcon}>
          <img
            src={`${AppConstants.WEBAPP_BASE_URL}/src/assets/images/no-of-settlement.png`}
            alt=""
          />
        </div>
        <div className={rsStyles.recentSettlementDetailsContent}>
          <h2 className={appStyles.colorDanger}>
            {settlementDetails?.totalSettledProperties}
          </h2>
          <p>Numbers of properties settled</p>
        </div>
      </div>

      <div className={rsStyles.recentSettlementDetailsWrap}>
        <div className={rsStyles.recentSettlementDetailsIcon}>
          <img
            src={`${AppConstants.WEBAPP_BASE_URL}/src/assets/images/total-settlement-amount.png`}
            alt=""
          />
        </div>
        <div className={rsStyles.recentSettlementDetailsContent}>
          <h2 className={appStyles.colorDanger}>
            
            <NumericFormat
              value={settlementDetails?.totalSettledAmount}
              //thousandsGroupStyle="lakh"
              thousandSeparator=","
              displayType="text"
              prefix="$"
            />
          </h2>

          <p>Total value of settlements</p>
        </div>
      </div>

      <div className={rsStyles.recentSettlementDetailsWrap}>
        <div className={rsStyles.recentSettlementDetailsIcon}>
          <img
            src={`${AppConstants.WEBAPP_BASE_URL}/src/assets/images/total-settlement-completed.png`}
            alt=""
          />
        </div>
        <div className={rsStyles.recentSettlementDetailsContent}>
          <h2 className={appStyles.colorDanger}>{"5000+"}</h2>
          <p>Settlements completed last 10 years</p>
        </div>
      </div>
    </>
  );
};

export default SettlementsDetails;
